export const accounts = [{
  id: 1,
  url: 'http://localhost:8000/api/users/1/',
  first_name: 'Test',
  last_name: 'Admin',
  email: 'dev.admin@gtintel.io',
  phone: '',
  alter_phone: null,
  authy_id: '',
  company: 'Ground Truth Intelligence',
  street_address: '27 Dev Test Rd',
  apartment: '',
  biography: null,
  tags: [],
  tag_groups: [{
    id: 1,
    name: 'Professional background',
    code: '1000',
    tags: [{
      id: 165,
      name: 'Academia',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 166,
      name: 'Banking and finance',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 167,
      name: 'Corporate intelligence',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 170,
      name: 'Government intelligence',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 171,
      name: 'Journalism',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 173,
      name: 'Management consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 174,
      name: 'Military',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 655,
      name: 'New of New',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 657,
      name: 'New of New 1111112564756890967534',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 175,
      name: 'Other business professional',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 176,
      name: 'Police/law enforcement',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 177,
      name: 'Political consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 178,
      name: 'Recruitment consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }]
  }],
  avatar: null,
  is_client: false,
  is_administrator: true,
  is_network_partner: false,
  accept_batch: false,
  timezone: 'America/New_York',
  dual_account: null,
  is_active: true,
  full_name: 'Test Admin',
  edit_role: false,
  is_auto_tag: true,
  is_deleted: false,
  notes: null,
  team: null,
  role: 1
}, {
  id: 2,
  url: 'http://localhost:8000/api/users/2/',
  first_name: 'Test',
  last_name: 'Client',
  email: 'dev.client@gtintel.io',
  phone: '',
  alter_phone: null,
  authy_id: '',
  company: 'Ground Truth Intelligence',
  street_address: '27 Dev Test Rd',
  apartment: '',
  biography: null,
  tags: [],
  tag_groups: [{
    id: 1,
    name: 'Professional background',
    code: '1000',
    tags: [{
      id: 165,
      name: 'Academia',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 166,
      name: 'Banking and finance',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 167,
      name: 'Corporate intelligence',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 170,
      name: 'Government intelligence',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 171,
      name: 'Journalism',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 173,
      name: 'Management consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 174,
      name: 'Military',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 655,
      name: 'New of New',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 657,
      name: 'New of New 1111112564756890967534',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 175,
      name: 'Other business professional',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 176,
      name: 'Police/law enforcement',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 177,
      name: 'Political consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 178,
      name: 'Recruitment consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }]
  }],
  avatar: null,
  is_client: true,
  is_administrator: false,
  is_network_partner: false,
  accept_batch: false,
  timezone: 'America/New_York',
  dual_account: null,
  is_active: true,
  full_name: 'Test Client',
  edit_role: true,
  is_auto_tag: true,
  is_deleted: false,
  notes: null,
  team: {
    id: 1,
    name: 'Test team'
  },
  role: 1
}, {
  id: 4,
  url: 'http://localhost:8000/api/users/4/',
  first_name: 'Test',
  last_name: 'Dual Account',
  email: 'dev.dual@gtintel.io',
  phone: null,
  alter_phone: null,
  authy_id: '',
  company: 'Ground Truth Intelligence',
  street_address: '27 Dev Test Rd',
  apartment: null,
  biography: null,
  tags: [],
  tag_groups: [],
  avatar: null,
  is_client: true,
  is_administrator: false,
  is_network_partner: false,
  accept_batch: false,
  timezone: 'America/New_York',
  dual_account: '4',
  is_active: true,
  full_name: 'Test Dual Account',
  edit_role: true,
  is_auto_tag: true,
  is_deleted: false,
  notes: null,
  team: {
    id: 1,
    name: 'Test team'
  },
  role: 1
}, {
  id: 3,
  url: 'http://localhost:8000/api/users/3/',
  first_name: 'Test',
  last_name: 'Partner',
  email: 'dev.partner@gtintel.io',
  phone: '',
  alter_phone: null,
  authy_id: '',
  company: 'Ground Truth Intelligence',
  street_address: '27 Dev Test Rd',
  apartment: '',
  biography: null,
  tags: [],
  tag_groups: [{
    id: 1,
    name: 'Professional background',
    code: '1000',
    tags: [{
      id: 165,
      name: 'Academia',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 166,
      name: 'Banking and finance',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 167,
      name: 'Corporate intelligence',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 170,
      name: 'Government intelligence',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 171,
      name: 'Journalism',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 173,
      name: 'Management consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 174,
      name: 'Military',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 655,
      name: 'New of New',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 657,
      name: 'New of New 1111112564756890967534',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 175,
      name: 'Other business professional',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 176,
      name: 'Police/law enforcement',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 177,
      name: 'Political consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }, {
      id: 178,
      name: 'Recruitment consultancy',
      tag_group_id: 1,
      tag_group_code: '1000',
      tag_group_name: 'Professional background'
    }]
  }],
  avatar: null,
  is_client: false,
  is_administrator: false,
  is_network_partner: true,
  accept_batch: false,
  timezone: 'America/New_York',
  dual_account: null,
  is_active: true,
  full_name: 'Test Partner',
  edit_role: false,
  is_auto_tag: true,
  is_deleted: false,
  notes: null,
  team: null,
  role: 1
}];
export const membercard = {
  id: 1,
  first_name: 'GTI',
  last_name: 'Staff'
};